import { createSlice } from '@reduxjs/toolkit';

export type LanguageType = '日本語' | 'English' | '中文' | 'Espanol';

export type LanguageDb = {
  name: LanguageType;
}

export type LanguageDbHashType = {
  [key in string]: LanguageDb;
}

export type LanguageAddPayload = {
  id?: string;
} & LanguageDb;
export type LanguageUpdatePayload = {
  id: string;
} & { [P in keyof LanguageDb]?: LanguageDb[P] };

export type LanguageDbState = {
  languages: LanguageDbHashType;
}

let initialState: LanguageDbState = { languages: {} };
initialState.languages['ja'] = { name: '日本語' };
initialState.languages['en'] = { name: 'English' };
initialState.languages['ch'] = { name: '中文' };
initialState.languages['es'] = { name: 'Espanol' };

const languageDbSlice = createSlice({
  name: 'languageDb',
  initialState,
  reducers: {
  }
})

export const languageDbGet = async () => {
  // axios.defaults.xsrfCookieName = 'csrftoken';
  // axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';

  // const res = await axios.get('languages/');
  // const ids = Object.keys(res.data);

  const hash: LanguageDbHashType = {};
  // ids.forEach(id => {
  //   const json = res.data[id];
  //   hash[id] = JSON.parse(json ?? '[]');
  // })

  return hash;
}

export default languageDbSlice.reducer;
